<div id="large-header" class="large-header" style="background-image: url('./assets/backgroundLanding.jpg')">
  <canvas id="demo-canvas"></canvas>
    <h1 class="main-title">{{'LOADING.TEXT_WELCOM' | translate}}<br><span class="thin">{{'LOADING.TEXT_CHANGE' | translate}}</span></h1>
</div>
